import { createEffectFn } from '@ngneat/effects';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap } from 'rxjs';

import { templatesService } from './templates.service';
import { TemplatesState } from './templates.store';

type SearchTemplatesParams = Partial<TemplatesState>

export const searchTemplatesEffect = createEffectFn((params$: Observable<SearchTemplatesParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => templatesService.getTemplates().pipe(catchError(() => EMPTY))),
  );
});